<div>
  <app-page>
    <app-page-title title="{{ 'MANAGE-ELEARNING.OVERVIEW.TITLE' | translate }}">

      <dx-button
        class="cta-btn"
        type="default"
        [disabled]="selectedElerningIds.length == 0"
        text="{{ 'MANAGE-ELEARNING.OVERVIEW.ARCHIVE' | translate }}"
        (click)="showArchiveModalHandle()"
      ></dx-button>

      <dx-button
        class="cta-btn"
        type="default"
        [disabled]="selectedElerningIds.length < 2"
        text="{{ 'MANAGE-ELEARNING.OVERVIEW.MERGE' | translate }}"
        (click)="showMergeModalHandle()"
      ></dx-button>

      <dx-button
        class="cta-btn"
        type="normal"
        icon="add"
        text="{{ 'MANAGE-ELEARNING.OVERVIEW.NEW-COURSE' | translate }}"
        (click)="navigateToNewCourse()"
      ></dx-button>
    </app-page-title>
    <app-table
      [data]="(allCourses$ | async) || []"
      [columns]="columns"
      [showSearch]="true"
      [showSelection]="true"
      [searchLabel]="'COMMON.SEARCH' | translate"
      [searchPlacehoder]="'COMMON.SEARCH' | translate"
      (onRowClick)="navigateToCourse($event)"
      (selectHandler)="onElerningsSelected($event)"
      [stateKey]="stateKey"
      [showFilterPanel]="true"
      [templates]="{
        statusTemplate: statusTemplate
      }"
    ></app-table>
     <ng-template #statusTemplate let-data>
      <ng-container *ngIf="data.data as course">
        <div class="status-badge-container">
          @if(course.isDeployed) {
            <span class="status-indicator published">
              <span class="dot"></span>
              {{ 'COMMON.PUBLICATION-STATUS.PUBLISHED' | translate }}
            </span>
          } @else {
            <span class="status-indicator draft">
              <span class="dot"></span>
              {{ 'COMMON.PUBLICATION-STATUS.DRAFT' | translate }}
            </span>
          }
        </div>
      </ng-container>
    </ng-template>
  </app-page>
</div>

<app-merge-elernings-modal
  *ngIf="showMergeModal"
  [(showModal)]="showMergeModal"
  [elernings]="selectedElerningsToMergeOrHide"
  (submit)="mergeElernings($event)"
></app-merge-elernings-modal>

<app-archive-elernings-modal
  *ngIf="showHideModal"
  [(showModal)]="showHideModal"
  [elernings]="selectedElerningsToMergeOrHide"
  (submit)="archiveElernings()"
></app-archive-elernings-modal>